import { buildColor } from "@tvg/design-system";
import styled from "styled-components";
import { FeaturePickerProps } from "./types";

export const FeaturePicker = styled.button<FeaturePickerProps>`
  margin: ${({ theme }) => `0 ${theme.space["space-4"]}`};
  padding: ${({ theme }) => `${theme.space["space-4"]}`};
  color: ${({ isActive }) =>
    isActive ? buildColor("blue_accent", "500") : buildColor("grey", "900")};
  background-color: ${({ isActive }) =>
    isActive ? buildColor("blue_accent", "100") : "transparent"};
  transition: background-color 0.2s ease-in-out;
  text-align: left;
  font: 500 14px "Roboto-Medium", sans-serif;
  border-radius: 4px;

  :hover {
    cursor: pointer;
  }

  &:first-child {
    margin-top: ${({ theme }) => theme.space["space-4"]};
  }
`;
